import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-moto-professionnelle',
  standalone: true,
  imports: [CommonModule, RouterModule, PageLayoutComponent],
  templateUrl: './assurance-moto-professionnelle.component.html',
  styleUrls: ['./assurance-moto-professionnelle.component.scss']
})
export class AssuranceMotoProfessionnelleComponent {
  title = 'Assurance Moto Professionnelle';
  subtitle = '';
  heroImage = 'assets/static_pages_images/MotoPersonnelle.jpg';

  breadcrumbs = [
    { label: 'Entreprises', link: undefined },
    { label: 'Assurance Moto Professionnelle', link: undefined }
  ];

  prevPage = { 
    title: 'Assurance Auto Professionnelle',
    link: '/assurance-auto-professionnelle'
  };

  nextPage = { 
    title: 'Assurance Flotte Auto Professionnelle',
    link: '/assurance-flotte-automobile'
  };

  partners = [
    { name: 'AMV', logo: 'assets/logos/amv.png' },
    { name: 'QIDFIL', logo: 'assets/logos/qidfil.png' },
    { name: 'XENASSUR', logo: 'assets/logos/xenassur.png' },
    { name: 'SWISSLIFE', logo: 'assets/logos/SWISSLIFE.PNG' },
    { name: 'PROGEAS', logo: 'assets/logos/progeas.png' },
    { name: 'NOVELIA', logo: 'assets/logos/novelia.png' },
    { name: 'ZEPHIR', logo: 'assets/logos/zephir.png' },
    { name: 'NETVOX', logo: 'assets/logos/netvox.png' }
  ];
}
